export enum OverallEquipmentEffectivenessType {
  NONE = 'NONE',
  DOWN_TIME_LOSS = 'DOWN_TIME_LOSS',
  NON_WORKING_TIME_LOSS = 'NON_WORKING_TIME_LOSS',
  PLANNED_TIME_LOSS = 'PLANNED_TIME_LOSS'
}
